import { contactUs } from '@/api/contact';

export default {
  namespaced: true,
  state: {
    success: null,
    loading: false,
  },
  mutations: {
    setSuccess(state, isSucceed) {
      state.success = isSucceed;
    },
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
  },
  actions: {
    async send({ commit, dispatch }, formData) {
      try {
        commit('setLoading', true);
        await contactUs(formData);
        commit('setSuccess', true);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
      } finally {
        commit('setLoading', false);
      }
    },
  },
  getters: {
    getSuccess: state => state.success,
    getLoading: state => state.loading,
  },
};
